module.exports = __webpack_public_path__ + "static/paris-023.thumb-a610765c35869eb129a9a814d91cd047.jpg";